import { render, staticRenderFns } from "./File-upload.vue?vue&type=template&id=7147f766&scoped=true&"
import script from "./File-upload.vue?vue&type=script&lang=js&"
export * from "./File-upload.vue?vue&type=script&lang=js&"
import style0 from "./File-upload.vue?vue&type=style&index=0&id=7147f766&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147f766",
  null
  
)

export default component.exports